import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PrimaryStarTooltip } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { P_REGULAR_SEMI_BOLD } from "../../../Constants/CommonConstants";
import {
  PREFERRED_CONTACT_TOOLTIP_ID,
  TOOLTIP_TEXT,
  TOP,
} from "../../../Constants/LoginVerificationMethodsConstants";

/**
 * @description ConditionalPrimaryStarTooltip component allows the user to add stared verification method.
 * @param {string} phoneEmailLabel string value to specify phone or email label.
 * @param {string} preferredContact specifies the current preferred contact method.
 * @returns {ReactNode} Renders star with tooltip for the preferred verification method.
 */

const ConditionalPrimaryStarTooltip = ({
  phoneEmailLabel,
  preferredContact,
}) => {
  const intl = useIntl();
  return (
    <Typography variant={P_REGULAR_SEMI_BOLD} id={phoneEmailLabel}>
      {intl.formatMessage({ id: phoneEmailLabel })}
      {preferredContact ? (
        <PrimaryStarTooltip
          tooltipText={intl.formatMessage({ id: TOOLTIP_TEXT })}
          placement={TOP}
          baseId={PREFERRED_CONTACT_TOOLTIP_ID}
        />
      ) : null}
    </Typography>
  );
};

ConditionalPrimaryStarTooltip.propTypes = {
  phoneEmailLabel: PropTypes.string.isRequired,
  preferredContact: PropTypes.string.isRequired,
};

export default ConditionalPrimaryStarTooltip;
